import React from 'react';
import { mediaDir } from '../../../../../appolloConfig';
import { ProductTypes } from '../../../../../types/product/product';
import useStyle from './productCardHeader.style';

export interface ProductCardMosaicHeaderProps {
  product: ProductTypes;
  className: any;
  onClick: () => void;
}

const ProductCardHeader = ({
  product,
  className,
  onClick
}: ProductCardMosaicHeaderProps) => {
  const classes = useStyle();
  return (
    <div className={className} onClick={onClick}>
      {product.media && product.media.length > 0 && (
        <div className={classes.imageContainer}>
          <img
            src={mediaDir + product?.media[0]?.url}
            alt={product?.name}
            className={classes.image}
          />
        </div>
      )}
    </div>
  );
};

export default ProductCardHeader;
